import { Field } from 'formik';
import type { FieldHookConfig, FieldProps } from 'formik';
import type { ReactElement } from 'react';

import type {
  SupportFormData,
  SupportFormFieldName,
  SupportFormFieldValue,
} from '../types';

export type SupportFormFieldProps<FieldName extends SupportFormFieldName> =
  Omit<
    FieldHookConfig<SupportFormFieldValue<FieldName>>,
    'name' | 'children' | 'component' | 'as' | 'render'
  > & {
    name: FieldName;
    children: (
      props: FieldProps<SupportFormFieldValue<FieldName>, SupportFormData>,
    ) => ReactElement;
  };

export const SupportFormField = <FieldName extends SupportFormFieldName>(
  props: SupportFormFieldProps<FieldName>,
) => <Field {...props} />;
